// @flow

import React, { Component } from "react";

import type { T_PDFJS, T_PDFJS_Document } from "../types";

import pdfjs from 'pdfjs-dist/webpack';

type Props = {
  url: string,
  beforeLoad: React$Element<*>,
  children: (pdfDocument: T_PDFJS_Document) => React$Element<*>
};

type State = {
  pdfDocument: ?T_PDFJS_Document
};

class PdfLoader extends Component<Props, State> {
  state = {
    pdfDocument: null
  };

  componentDidMount() {
    const { url } = this.props;
    var loadingTask = pdfjs.getDocument(url);

    if (this.props.progressCallback)
      loadingTask.onProgress = this.props.progressCallback;

    loadingTask.then(pdfDocument => {
      this.setState({
        pdfDocument: pdfDocument
      });

    });
  }

  render() {
    const { children, beforeLoad } = this.props;
    const { pdfDocument } = this.state;

    if (pdfDocument) {
      return children(pdfDocument);
    }

    return beforeLoad;
  }
}

export default PdfLoader;



// WEBPACK FOOTER //
// ./src/components/PdfLoader.js